var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/no-cycle,consistent-return,default-case */
import React from 'react';
import styled, { ThemeProvider, withTheme, } from '@empiriecom/module-components/utils/styled-components';
import { css } from '@empiriecom/module-components/utils/styled-components';
import buildLinkWithArguments from '../../utils/buildLinkWithArguments';
import useIcon from '@empiriecom/module-components/utils/getIcon';
import iconPreparer from '../../utils/iconPreparer';
import linkTheme from './theme';
import useConfig from '../hooks/useConfig';
export var LinkByTextTestIds;
(function (LinkByTextTestIds) {
    LinkByTextTestIds["LinkByTextId"] = "cmsTextLink__testid";
})(LinkByTextTestIds || (LinkByTextTestIds = {}));
export var baseLinkStyles = function (_a) {
    var component = _a.component;
    return "\n  display: inline-block;\n  cursor: pointer;\n  color: " + component.link.base.color + ";\n  text-decoration: " + component.link.base.textDecoration + ";\n  font-weight: bold;\n\n  &:active,\n  &:hover {\n    outline-width: 0;\n    color: " + component.link.base.hover.color + ";\n    text-decoration: " + component.link.base.hover.textDecoration + ";\n  }\n";
};
var StyledLink = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", "\n"], ["\n  ", ";\n  ",
    "\n"])), function (_a) {
    var compTheme = _a.theme;
    return baseLinkStyles(compTheme);
}, function (_a) {
    var component = _a.theme.component, withicon = _a.withicon, iconplacement = _a.iconplacement;
    return withicon && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n      ", ": 1.15rem;\n      & svg {\n        position: absolute;\n        top: 50%;\n        width: 0.875rem;\n        height: 0.875rem;\n        ", ": 0.25rem;\n        transform: translate(0, -50%);\n        font-size: ", ";\n      }\n    "], ["\n      position: relative;\n      ", ": 1.15rem;\n      & svg {\n        position: absolute;\n        top: 50%;\n        width: 0.875rem;\n        height: 0.875rem;\n        ", ": 0.25rem;\n        transform: translate(0, -50%);\n        font-size: ", ";\n      }\n    "])), iconplacement === 'left' ? 'padding-left' : 'padding-right', iconplacement === 'left' ? 'left' : 'right', component.link.icon.fontSize);
});
var LinkByText = function (_a) {
    var _b;
    var contentData = _a.contentData;
    var text = contentData.field_text, _c = contentData.field_link, link = _c === void 0 ? '' : _c, linkTarget = contentData.field_link_target, _d = contentData.field_icon, iconType = _d === void 0 ? '' : _d, iconPlacement = contentData.field_direction, 
    /* eslint-disable @typescript-eslint/naming-convention */
    field_tracking = contentData.field_tracking, field_link_anchor = contentData.field_link_anchor, field_link_highlight = contentData.field_link_highlight, field_link_searchfilter = contentData.field_link_searchfilter, field_bonus_number = contentData.field_bonus_number;
    var config = useConfig();
    var prepareIcon = iconPreparer(iconType, (_b = config === null || config === void 0 ? void 0 : config.drupalIconMapper) === null || _b === void 0 ? void 0 : _b.values);
    var Icon = prepareIcon && useIcon(prepareIcon);
    var IconElement = Icon && React.createElement(Icon, null);
    var AnchorTag = function () { return (React.createElement(StyledLink, { "data-testid": LinkByTextTestIds.LinkByTextId, href: buildLinkWithArguments(link, {
            field_tracking: field_tracking,
            field_link_anchor: field_link_anchor,
            field_link_highlight: field_link_highlight,
            field_link_searchfilter: field_link_searchfilter,
            field_bonus_number: field_bonus_number,
        }), target: linkTarget, withicon: iconType !== '', iconplacement: iconPlacement }, iconPlacement === 'left' ? (React.createElement(React.Fragment, null,
        iconType && IconElement,
        text)) : (React.createElement(React.Fragment, null,
        text,
        iconType && IconElement)))); };
    return (React.createElement(ThemeProvider, { theme: linkTheme },
        React.createElement(AnchorTag, null)));
};
export default withTheme(LinkByText);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map